import { DocumentsMasterActions } from "./DocumentMasterAction";

const initialState = {
  masterLoading: false,
  companyDocumentsList: [],
  partnerDocumentsList: [],
  partnerSignatoryDocumentsList: [],
  allDocuments: "",
};

const DocumentMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case DocumentsMasterActions.GET_DOCUMENTS_MASTER_SUCCESS:
      return {
        ...state,
        companyDocumentsList: action.payload?.partnerCompanyDocumentsList,
        partnerDocumentsList: action.payload?.partnerTeamDocumentsDTOList,
        partnerSignatoryDocumentsList:
          action.payload?.partnerSignatoryDocumentsList,
        allDocuments: action.payload,
        masterLoading: false,
      };

    case DocumentsMasterActions.GET_DOCUMENTS_MASTER_ERROR:
      return {
        ...state,
        masterLoading: false,
        companyDocumentsList: [],
        partnerDocumentsList: [],
        partnerSignatoryDocumentsList: [],
        allDocuments: "",
      };

    case DocumentsMasterActions.GET_DOCUMENTS_MASTER_LOADING:
      return {
        ...state,
        masterLoading: true,
      };

    default:
      return state;
  }
};

export default DocumentMasterReducer;
